module.exports = __webpack_public_path__ + "static/media/ZHUHAI-1 OHS-03.06c8d5ca.czml";